import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
// import 'default-passive-events'
import 'element-ui/lib/theme-chalk/index.css'
import './permission.js'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import '@/styles/index.less' // global css
import * as filters from '@/utils/filters'
import baseComponents from '@/components/base'
import VueAMap from 'vue-amap'
import {ossUrl} from '@/utils/config'
import track from './utils/track'
// Vue.use(VueAwesomeSwiper)

Vue.use(ElementUI)
Vue.use(baseComponents)
Vue.config.productionTip = false

// 埋点方法放在vue的原型链上
Vue.prototype.$track = track.statisData

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'ddede11ac5cf8e7d7891cf33be56db51',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.15',
  uiVersion: '1.0.11'
})

Vue.directive('has', {
  // 指令的定义
  inserted(el, binding) {
    let types = store.state.permission.hadBtn
    if (!types) return false
    if (types.indexOf(binding.value) === -1) {
      el.parentNode.removeChild(el)
    }
  }
})
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

Vue.prototype.$ossUrl = ossUrl

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
